module.exports = __webpack_public_path__ + "static/media/accuracy-icon.9c6f1e0f.svg";